export class ApiGatewayConstants {
    static internalGatewayTypes = [
        {
            displayName: 'apiplatform',
            image: './assets/logo/logo.png',
            value: 'kong',
            provider: 'external',
            selected: true,
            disabled: false,
            description: 'An performance enhanced API gateway that provides high performance, reliability, and scalability for microservices and APIs.'
        },
    ];
    static externalGatewayTypes = [
        {
            displayName: 'AWS API Gateway',
            image: './assets/img/partnerOnboarding/awsGateway.png',
            value: 'aws',
            provider: 'external',
            selected: false,
            disabled: false,
            description: 'A fully managed service that makes it easy for developers to create, publish, and manage APIs at any scale.'
        },
        {
            displayName: 'Azure API Management',
            image: './assets/img/partnerOnboarding/azure.png',
            value: 'azure',
            provider: 'external',
            selected: false,
            disabled: false,
            description: 'A fully managed service that makes it easy for developers to create, publish, and manage APIs at any scale.'
        },
        {
            displayName: 'Apigee',
            image: './assets/img/partnerOnboarding/apigee.png',
            value: 'apigee',
            provider: 'external',
            selected: false,
            disabled: true,
            description: 'A full-featured API platform that enables enterprises to design, secure, publish, and analyze APIs, and build digital ecosystems'
        },
        {
            displayName: 'Kong',
            image: './assets/img/kong.png',
            value: 'kong',
            provider: 'external',
            selected: false,
            disabled: true,
            description: 'An open-source API gateway that provides high performance, reliability, and scalability for microservices and APIs.'
        },
    ];
}
